<template>
  <div class="container" id="jump1">
    <!-- 顶部导航栏 -->
    <HeadTab :typeindex="3" isshow="1"></HeadTab>
    <!-- <img class="opl" src="/static/img/Mask_group.png" alt="" /> -->
    <div class="obtain">
      <div class="document_inner">
        <div class="document_left">
          <div class="ikd">
            <div class="breadcrumb"  @click="$router.push('/')">Главная</div>
            <img class="mle" src="/static/img/jt.png" alt="" />
            <div class="njk">Документы</div>
          </div>
          <div class="document_title">Документы</div>
          <div class="document_card">
            <div class="document_card-title">ВАЖНЫЕ ДОКУМЕНТЫ</div>
            <div class="document_item" v-for="(item,index) in documentList" :key="index" @click="getdocum(item.link)">
              <div class="document_item-text">{{ item.title }}</div>
              <div class="document_item-arrow">›</div>
            </div>
          </div>
        </div>
        <div class="document_right">
          <LoanCard :bgindex="2"></LoanCard>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <BomTab :jumpindex="1" jumpurl="/conte"></BomTab>
  </div>
</template>

<script>
  import HeadTab from '@/components/HeadTab.vue'
  import BomTab from '@/components/BomTab.vue'
  import LoanCard from '@/components/loancard.vue'
  export default {
    name: "conte",
    data() {
      return {
        documentList: [
          { title: 'Правила предоставления микрокредитов' ,
          link: 'https://aicredit.kz/microcreditrules.pdf'},
          { title: 'Процедура безопасности',
          link: 'https://aicredit.kz/securityprocedure.pdf'},
          { title: 'Порядок урегулирования задолженности',
          link: 'https://aicredit.kz/debtsettlementprocedure.pdf'},
          { title: 'Договор онлайн микрокредита',
          link: 'https://aicredit.kz/microcreditagreement.pdf'},
          { title: 'Политика конфиденциальности',
          link: 'https://aicredit.kz/privacypolicy.pdf'},
          { title: 'УСЛОВИЯ ОПЛАТЫ И ВОЗВРАТА',
          link: 'https://aicredit.kz/provision.pdf'}
        ]
      };
    },
    components: {
      BomTab,
      HeadTab,
      LoanCard
    },
    mounted () {
    },
    methods: {
      getdocum(e){
        location.href = e
      }
    },
  };
</script>

<style scoped>
  .opl{
    width: 2.6rem;
    height: 2.6rem;
    position: absolute;
    top: 0.26rem;
    right: 1.53rem;
    z-index: 0;
  }
  .obtain {
    background: #FFF8F6;
    padding: 0.78rem 1.58rem 1.4rem;
  }
  .document_inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 0.94rem;
  }
  .document_left {
    width: 3.11rem;
  }
  .ikd{
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 0.08rem;
  }
  .breadcrumb {
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.07rem;
    color: #5B403B;
    text-align: left;
    font-style: normal;
    cursor: pointer;
    z-index: 999999;
  }
  .mle {
    width: 0.1rem;
    height: fit-content;
    margin: 0.03rem 0.01rem 0;
  }
  .njk{
    font-family: Inter, Inter;
    font-weight: 500;
    font-size: 0.07rem;
    color: #FF5836;
    text-align: left;
    font-style: normal;
  }
  .document_title {
    font-family: Inter, Inter;
    font-weight: 900;
    font-size: 0.31rem;
    color: #333333;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.25rem;
  }
  .document_card-title {
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 0.06rem;
    color: #FF5836;
    text-align: left;
    font-style: normal;
    margin-bottom: 0.13rem;
  }
  .document_item {
    border-radius: 0.06rem;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.13rem;
    margin-bottom: 0.08rem;
    cursor: pointer;
  }
  .document_item:last-child {
    margin-bottom: 0;
  }
  .document_item-text {
    color: #333333;
    font-family: Inter, Inter;
    font-weight: normal;
    font-size: 0.09rem;
  }
  .document_item-arrow {
    color: #5B403B;
    font-family: Montserrat;
    font-weight: 600;
    font-size: 0.13rem;
    line-height: 1;
  }

  @media screen and (max-width: 1200px) {
    .obtain {
      padding-left: 0.4rem;
      padding-right: 0.4rem;
    }
    .document_inner {
      gap: 0.24rem;
    }
    .document_left,
    .document_right {
      width: 50%;
    }
  }

  @media screen and (max-width: 768px) {
    .opl{
      width: 2.29rem;
      height: 1.32rem;
      position: absolute;
      top: 0.95rem;
      left: 0;
    }
    .obtain {
      padding-top: 0.42rem;
      padding-bottom: 0.48rem;
    }
    .document_inner {
      flex-direction: column;
    }
    .document_left,
    .document_right {
      width: 100%;
    }
    .document_title {
      font-size: 0.24rem;
      line-height: 0.3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/conte.vue